"use strict";

exports.validateNumber = function (phoneStr) {
  if (!phoneStr) {
    return true;
  }
  var str = phoneStr.toString().match(/[0-9]/g);
  return str && str.length > 7;
};